export default {
    data() {
        return {
            //domain: 'http://165.22.78.11/',
            domain: process.env.MIX_APP_URL,
            paths: {
                reservation: "reservation",
                smail: "smail",
            }

        }
    },
    methods: {
        async sts(type, path, form, id) {
            const my = axios.create({
                baseURL: this.domain,
                timeout: 50000,
                headers: {
                    "X-Custom-Header": "foobar"
                }
            });

            switch (type) {
                case "get":
                    return await my[type](path + "/" + id);
                    break;
                case "post":
                    return await my[type](path, form);
                    break;
                case "patch":
                    return await my[type](path + "/" + id, form);
                    break;
                case "delete":
                    return await my[type](path + "/" + id);
                    break;
            }
        },

        inRange(start, stop, x) {
            return (x >= start && x <= stop)
        },
        l(param) {
            let l = this.langs.find(o => o.key == param);
            return l ? l.value : param;

        },
        calcDateTime(date1, date2) {
            var date1 = new Date(date1);
            var date2 = new Date(date2);
            var dani = date2.getTime() - date1.getTime();
            return dani / (1000 * 3600 * 24);
        },
        changeTimeFormat(param) {
            let o = [];
            let out = '';
            o = param.split(':');
            if (param.indexOf('PM') > -1) {
                o[0] = parseInt(o[0]) + 12;
            }

            o.splice(2, 1);
            o.push('00');
            out = o.join(':')
            return out
        },
        transformSendForm(param) {
            let form = {};
            for (let i in param) {
                if (i == 'car' || i == 'start_city' || i == 'stop_city') {
                    if (param[i].id) {
                        if (i == 'car') {
                            form['vehicle_id'] = param[i].id
                        } else {
                            form[i] = param[i].id
                        }
                    }
                } else {
                    if (i == 'start_date' || i == 'stop_date') {
                        let temp = param[i].split('/').reverse();
                        form[i] = temp[0] + '-' + temp[2] + '-' + temp[1]
                    } else {
                        form[i] = param[i];
                    }

                }
            }

            let start_time = this.changeTimeFormat(form.start_time);
            let stop_time = this.changeTimeFormat(form.stop_time);
            form.start_date = form.start_date + ' ' + start_time;
            form.stop_date = form.stop_date + ' ' + stop_time;
            form.office_start_id = form.office_start_id;
            form.office_stop_id = form.office_stop_id;
            delete form.start_time;
            delete form.stop_time;
            delete form.start_city;
            delete form.stop_city;
            return form;
        },
        validateSelect(param, type) {
            let state = true;
            if (param == "0") {
                this.error[type] = true;
                state = false;
            }

            return state;
        },
        validateLocation(param, type) {
            console.log(param);
            let state = true;
            if (!param) {
                this.error[type] = true;
                state = false;
            }
            return state;
        },
        validateDate(param, type) {
            console.log(param + " " + type);
            let state = param.split("/").length == 3;
            if (!state) {
                this.error[type] = true;
            }
            return state;
        },
        validateTime(param, type) {
            let state = param.split(" ").length == 3;
            if (!state) {
                this.error[type] = true;
            }
            return state;
        },
        getRange() {
            for (let i = 0; i < 12; i++) {
                this.range.push(i.toString());
            }
        },
        makeDateTime() {
            this.getRange();
            let self = this;
            let min = ["00", "30"];
            let day = ["AM", "PM"];
            day.forEach(day => {
                self.range.forEach(range => {
                    range = range.length == 1 ? "0" + range : range;
                    min.forEach(min => {
                        self.dt.push({
                            h: range,
                            m: min,
                            d: day
                        });
                    });
                });
            });
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/site.js